/* Publish by EComposer at 2026-11-03 14:24:22*/
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-qtyuo6cmmr"]=  window.__ectimmers["ecom-qtyuo6cmmr"] || {};
if(!this.$el)return;const t=this.$el,e=t.querySelector(".ecom-text_view-more-btn"),i=t.querySelector(".ecom-text_view-less-btn"),n=t.querySelector(".text-content.ecom-html");!n||(e&&e.addEventListener("click",()=>{n.classList.remove("ecom-text--is-mark"),n.style.maxHeight="",e.style.display="none",i.style.display=""}),i&&i.addEventListener("click",()=>{n.classList.add("ecom-text--is-mark"),n.style.maxHeight="var(--ecom-text-height)",i.style.display="none",e.style.display=""}))

                    });
                    
                        document.querySelectorAll('.ecom-qtyuo6cmmr').forEach(function(el){
                            try {
                                Func.call({$el: el, id: 'ecom-qtyuo6cmmr', settings: {},isLive: true});
                            } catch (e) {
                                console.error('[EComposer] ecom-qtyuo6cmmr', e);
                            }
                        });
                    
                        document.querySelectorAll('.ecom-c2df9c6b3nk').forEach(function(el){
                            try {
                                Func.call({$el: el, id: 'ecom-c2df9c6b3nk', settings: {},isLive: true});
                            } catch (e) {
                                console.error('[EComposer] ecom-c2df9c6b3nk', e);
                            }
                        });
                    
                        document.querySelectorAll('.ecom-wkvp6z0xge').forEach(function(el){
                            try {
                                Func.call({$el: el, id: 'ecom-wkvp6z0xge', settings: {},isLive: true});
                            } catch (e) {
                                console.error('[EComposer] ecom-wkvp6z0xge', e);
                            }
                        });
                    
                        document.querySelectorAll('.ecom-fimnk9be5ka').forEach(function(el){
                            try {
                                Func.call({$el: el, id: 'ecom-fimnk9be5ka', settings: {},isLive: true});
                            } catch (e) {
                                console.error('[EComposer] ecom-fimnk9be5ka', e);
                            }
                        });
                    
                        document.querySelectorAll('.ecom-rh135t3z7z').forEach(function(el){
                            try {
                                Func.call({$el: el, id: 'ecom-rh135t3z7z', settings: {},isLive: true});
                            } catch (e) {
                                console.error('[EComposer] ecom-rh135t3z7z', e);
                            }
                        });
                    
                        document.querySelectorAll('.ecom-5ay9v1b49jb').forEach(function(el){
                            try {
                                Func.call({$el: el, id: 'ecom-5ay9v1b49jb', settings: {},isLive: true});
                            } catch (e) {
                                console.error('[EComposer] ecom-5ay9v1b49jb', e);
                            }
                        });
                    
                        document.querySelectorAll('.ecom-qjxahjgesjr').forEach(function(el){
                            try {
                                Func.call({$el: el, id: 'ecom-qjxahjgesjr', settings: {},isLive: true});
                            } catch (e) {
                                console.error('[EComposer] ecom-qjxahjgesjr', e);
                            }
                        });
                    
                        document.querySelectorAll('.ecom-qjihoavso6').forEach(function(el){
                            try {
                                Func.call({$el: el, id: 'ecom-qjihoavso6', settings: {},isLive: true});
                            } catch (e) {
                                console.error('[EComposer] ecom-qjihoavso6', e);
                            }
                        });
                    
                        document.querySelectorAll('.ecom-ta4iuilpt7e').forEach(function(el){
                            try {
                                Func.call({$el: el, id: 'ecom-ta4iuilpt7e', settings: {},isLive: true});
                            } catch (e) {
                                console.error('[EComposer] ecom-ta4iuilpt7e', e);
                            }
                        });
                    
                        document.querySelectorAll('.ecom-9grx3bb54b').forEach(function(el){
                            try {
                                Func.call({$el: el, id: 'ecom-9grx3bb54b', settings: {},isLive: true});
                            } catch (e) {
                                console.error('[EComposer] ecom-9grx3bb54b', e);
                            }
                        });
                    
                        document.querySelectorAll('.ecom-aqg9tibs05o').forEach(function(el){
                            try {
                                Func.call({$el: el, id: 'ecom-aqg9tibs05o', settings: {},isLive: true});
                            } catch (e) {
                                console.error('[EComposer] ecom-aqg9tibs05o', e);
                            }
                        });
                    
                        document.querySelectorAll('.ecom-ou2pxk7hh6').forEach(function(el){
                            try {
                                Func.call({$el: el, id: 'ecom-ou2pxk7hh6', settings: {},isLive: true});
                            } catch (e) {
                                console.error('[EComposer] ecom-ou2pxk7hh6', e);
                            }
                        });
                    
                        document.querySelectorAll('.ecom-ktt0ux2zoq').forEach(function(el){
                            try {
                                Func.call({$el: el, id: 'ecom-ktt0ux2zoq', settings: {},isLive: true});
                            } catch (e) {
                                console.error('[EComposer] ecom-ktt0ux2zoq', e);
                            }
                        });
                    
                        document.querySelectorAll('.ecom-t69wqrcyweo').forEach(function(el){
                            try {
                                Func.call({$el: el, id: 'ecom-t69wqrcyweo', settings: {},isLive: true});
                            } catch (e) {
                                console.error('[EComposer] ecom-t69wqrcyweo', e);
                            }
                        });
                    
                        document.querySelectorAll('.ecom-97h20f7rddk').forEach(function(el){
                            try {
                                Func.call({$el: el, id: 'ecom-97h20f7rddk', settings: {},isLive: true});
                            } catch (e) {
                                console.error('[EComposer] ecom-97h20f7rddk', e);
                            }
                        });
                    
                        document.querySelectorAll('.ecom-ehwblikij3o').forEach(function(el){
                            try {
                                Func.call({$el: el, id: 'ecom-ehwblikij3o', settings: {},isLive: true});
                            } catch (e) {
                                console.error('[EComposer] ecom-ehwblikij3o', e);
                            }
                        });
                    
                        document.querySelectorAll('.ecom-du9w3efhh0n').forEach(function(el){
                            try {
                                Func.call({$el: el, id: 'ecom-du9w3efhh0n', settings: {},isLive: true});
                            } catch (e) {
                                console.error('[EComposer] ecom-du9w3efhh0n', e);
                            }
                        });
                    
                        document.querySelectorAll('.ecom-31eqt9imsnf').forEach(function(el){
                            try {
                                Func.call({$el: el, id: 'ecom-31eqt9imsnf', settings: {},isLive: true});
                            } catch (e) {
                                console.error('[EComposer] ecom-31eqt9imsnf', e);
                            }
                        });
                    
                        document.querySelectorAll('.ecom-hq98jj8ycm').forEach(function(el){
                            try {
                                Func.call({$el: el, id: 'ecom-hq98jj8ycm', settings: {},isLive: true});
                            } catch (e) {
                                console.error('[EComposer] ecom-hq98jj8ycm', e);
                            }
                        });
                    
                        document.querySelectorAll('.ecom-8rhrnfohyua').forEach(function(el){
                            try {
                                Func.call({$el: el, id: 'ecom-8rhrnfohyua', settings: {},isLive: true});
                            } catch (e) {
                                console.error('[EComposer] ecom-8rhrnfohyua', e);
                            }
                        });
                    
                        document.querySelectorAll('.ecom-uoa21xncix').forEach(function(el){
                            try {
                                Func.call({$el: el, id: 'ecom-uoa21xncix', settings: {},isLive: true});
                            } catch (e) {
                                console.error('[EComposer] ecom-uoa21xncix', e);
                            }
                        });
                    
                        document.querySelectorAll('.ecom-al3k08aikfu').forEach(function(el){
                            try {
                                Func.call({$el: el, id: 'ecom-al3k08aikfu', settings: {},isLive: true});
                            } catch (e) {
                                console.error('[EComposer] ecom-al3k08aikfu', e);
                            }
                        });
                    
                        document.querySelectorAll('.ecom-sph6ra30ser').forEach(function(el){
                            try {
                                Func.call({$el: el, id: 'ecom-sph6ra30ser', settings: {},isLive: true});
                            } catch (e) {
                                console.error('[EComposer] ecom-sph6ra30ser', e);
                            }
                        });
                    
                        document.querySelectorAll('.ecom-qjy32h7x9rp').forEach(function(el){
                            try {
                                Func.call({$el: el, id: 'ecom-qjy32h7x9rp', settings: {},isLive: true});
                            } catch (e) {
                                console.error('[EComposer] ecom-qjy32h7x9rp', e);
                            }
                        });
                    
                        document.querySelectorAll('.ecom-d9bdzwj1ms').forEach(function(el){
                            try {
                                Func.call({$el: el, id: 'ecom-d9bdzwj1ms', settings: {},isLive: true});
                            } catch (e) {
                                console.error('[EComposer] ecom-d9bdzwj1ms', e);
                            }
                        });
                    
                        document.querySelectorAll('.ecom-v2cct3sz47r').forEach(function(el){
                            try {
                                Func.call({$el: el, id: 'ecom-v2cct3sz47r', settings: {},isLive: true});
                            } catch (e) {
                                console.error('[EComposer] ecom-v2cct3sz47r', e);
                            }
                        });
                    
                        document.querySelectorAll('.ecom-p1aepxwwlxa').forEach(function(el){
                            try {
                                Func.call({$el: el, id: 'ecom-p1aepxwwlxa', settings: {},isLive: true});
                            } catch (e) {
                                console.error('[EComposer] ecom-p1aepxwwlxa', e);
                            }
                        });
                    
                        document.querySelectorAll('.ecom-qk2zx10gjv9').forEach(function(el){
                            try {
                                Func.call({$el: el, id: 'ecom-qk2zx10gjv9', settings: {},isLive: true});
                            } catch (e) {
                                console.error('[EComposer] ecom-qk2zx10gjv9', e);
                            }
                        });
                    
                        document.querySelectorAll('.ecom-0xws09normz').forEach(function(el){
                            try {
                                Func.call({$el: el, id: 'ecom-0xws09normz', settings: {},isLive: true});
                            } catch (e) {
                                console.error('[EComposer] ecom-0xws09normz', e);
                            }
                        });
                    

                })();
            
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-zqcrpu5jst"]=  window.__ectimmers["ecom-zqcrpu5jst"] || {};
if(!this.$el)return!1;const t=this.$el;this.settings.animation&&function(i){if(!t)return;const n=t.querySelector(".ecom__element--button");if(!n)return;let o=parseInt(i.settings.animation_loop_time)*1e3||6e3,s=1e3;window.__ectimmers["ecom-zqcrpu5jst"]["v4ad93neb"] = setInterval(function(){n.classList.add("animated"),setTimeout(function(){n.classList.remove("animated")},s)},o)}(this);var e=t.querySelector(".ecom__element--button");this.isLive&&e&&e.dataset.ecTrackingId&&e.addEventListener("click",function(i){if(window.Shopify&&window.Shopify.analytics){i.preventDefault();let n=window.EComposer.PAGE||window.EComposer.TEMPLATE||window.EComposer.SECTION||window.EComposer.BLOCK||{};const o=Object.assign({button_id:e.id,tracking_id:e.dataset.ecTrackingId},n);try{Shopify.analytics.publish("ec_custom_events",o)}catch(a){console.error("[EC Tracking] Error publishing analytics event:",a)}const s=e.getAttribute("href"),r=e.getAttribute("target");s&&s!=="#"&&s!=="javascript:void(0)"&&(r==="_blank"?window.open(s,"_blank"):setTimeout(function(){window.location.href=s},300))}},{once:!0}),this.isLive&&e&&e.dataset.eventTrackingFb&&e.addEventListener("click",function(i){window.fbq&&window.fbq("track",`${e.dataset.eventTrackingFb}`)},{once:!0})

                    });
                    
                        document.querySelectorAll('.ecom-zqcrpu5jst').forEach(function(el){
                            try {
                                Func.call({$el: el, id: 'ecom-zqcrpu5jst', settings: {"animation":false},isLive: true});
                            } catch (e) {
                                console.error('[EComposer] ecom-zqcrpu5jst', e);
                            }
                        });
                    
                        document.querySelectorAll('.ecom-xgz88dgopo').forEach(function(el){
                            try {
                                Func.call({$el: el, id: 'ecom-xgz88dgopo', settings: {"animation":false},isLive: true});
                            } catch (e) {
                                console.error('[EComposer] ecom-xgz88dgopo', e);
                            }
                        });
                    
                        document.querySelectorAll('.ecom-6izk8tmz2n9').forEach(function(el){
                            try {
                                Func.call({$el: el, id: 'ecom-6izk8tmz2n9', settings: {"animation":false},isLive: true});
                            } catch (e) {
                                console.error('[EComposer] ecom-6izk8tmz2n9', e);
                            }
                        });
                    
                        document.querySelectorAll('.ecom-3xrv03btxsv').forEach(function(el){
                            try {
                                Func.call({$el: el, id: 'ecom-3xrv03btxsv', settings: {"animation":false},isLive: true});
                            } catch (e) {
                                console.error('[EComposer] ecom-3xrv03btxsv', e);
                            }
                        });
                    
                        document.querySelectorAll('.ecom-1d877sefa2u').forEach(function(el){
                            try {
                                Func.call({$el: el, id: 'ecom-1d877sefa2u', settings: {"animation":false},isLive: true});
                            } catch (e) {
                                console.error('[EComposer] ecom-1d877sefa2u', e);
                            }
                        });
                    
                        document.querySelectorAll('.ecom-p22cazbi0rc').forEach(function(el){
                            try {
                                Func.call({$el: el, id: 'ecom-p22cazbi0rc', settings: {"animation":false},isLive: true});
                            } catch (e) {
                                console.error('[EComposer] ecom-p22cazbi0rc', e);
                            }
                        });
                    
                        document.querySelectorAll('.ecom-yfxl0cdug1e').forEach(function(el){
                            try {
                                Func.call({$el: el, id: 'ecom-yfxl0cdug1e', settings: {"animation":false},isLive: true});
                            } catch (e) {
                                console.error('[EComposer] ecom-yfxl0cdug1e', e);
                            }
                        });
                    
                        document.querySelectorAll('.ecom-xylfenpeolo').forEach(function(el){
                            try {
                                Func.call({$el: el, id: 'ecom-xylfenpeolo', settings: {"animation":false},isLive: true});
                            } catch (e) {
                                console.error('[EComposer] ecom-xylfenpeolo', e);
                            }
                        });
                    
                        document.querySelectorAll('.ecom-ono4x471oqh').forEach(function(el){
                            try {
                                Func.call({$el: el, id: 'ecom-ono4x471oqh', settings: {"animation":false},isLive: true});
                            } catch (e) {
                                console.error('[EComposer] ecom-ono4x471oqh', e);
                            }
                        });
                    
                        document.querySelectorAll('.ecom-5jmrngdsn49').forEach(function(el){
                            try {
                                Func.call({$el: el, id: 'ecom-5jmrngdsn49', settings: {"animation":false},isLive: true});
                            } catch (e) {
                                console.error('[EComposer] ecom-5jmrngdsn49', e);
                            }
                        });
                    
                        document.querySelectorAll('.ecom-lwyv2hojq6d').forEach(function(el){
                            try {
                                Func.call({$el: el, id: 'ecom-lwyv2hojq6d', settings: {"animation":false},isLive: true});
                            } catch (e) {
                                console.error('[EComposer] ecom-lwyv2hojq6d', e);
                            }
                        });
                    
                        document.querySelectorAll('.ecom-nhxwycu2h').forEach(function(el){
                            try {
                                Func.call({$el: el, id: 'ecom-nhxwycu2h', settings: {"animation":false},isLive: true});
                            } catch (e) {
                                console.error('[EComposer] ecom-nhxwycu2h', e);
                            }
                        });
                    
                        document.querySelectorAll('.ecom-derm67rk8cp').forEach(function(el){
                            try {
                                Func.call({$el: el, id: 'ecom-derm67rk8cp', settings: {"animation":false},isLive: true});
                            } catch (e) {
                                console.error('[EComposer] ecom-derm67rk8cp', e);
                            }
                        });
                    

                })();
            
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-9zi4v2ezrp6"]=  window.__ectimmers["ecom-9zi4v2ezrp6"] || {};
const t=function(r){if(window.EComModal)return r();if(window.EComposer&&typeof window.EComposer.loadVendor=="function"){window.EComposer.loadVendor("modal_js").then(function(){window.EComModal&&r()});return}let a=0;const l= window.__ectimmers["ecom-9zi4v2ezrp6"]["8ei9c4t8t"] = setInterval(function(){window.EComModal?(clearInterval(l),r()):++a>=300&&clearInterval(l)},50)};if(this.settings.link==="lightbox"&&this.settings.lightbox==="yes"&&this.$el){var e=this.$el.querySelector("[ecom-modal]"),i=this.id;t(function(){new window.EComModal(e,{cssClass:["ecom-container-lightbox-"+i]})})}let n=this.$el;if(!n)return;function o(r){const a=r.getBoundingClientRect();return a.top>=0&&a.left>=0&&a.bottom-r.offsetHeight/2<=(window.innerHeight||document.documentElement.clientHeight)&&a.right<=(window.innerWidth||document.documentElement.clientWidth)}function s(){let r=n.querySelector(".ecom-element.ecom-base-image"),a=n.closest(".core__row--columns");r&&(o(r)?(r.classList.add("image-highlight"),a.setAttribute("style","z-index: unset")):(r.classList.remove("image-highlight"),a.setAttribute("style","z-index: 1")))}this.settings.highligh_on_viewport&&window.addEventListener("scroll",function(){s()})

                    });
                    
                        document.querySelectorAll('.ecom-9zi4v2ezrp6').forEach(function(el){
                            try {
                                Func.call({$el: el, id: 'ecom-9zi4v2ezrp6', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                            } catch (e) {
                                console.error('[EComposer] ecom-9zi4v2ezrp6', e);
                            }
                        });
                    
                        document.querySelectorAll('.ecom-d6eo1pbgxkf').forEach(function(el){
                            try {
                                Func.call({$el: el, id: 'ecom-d6eo1pbgxkf', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                            } catch (e) {
                                console.error('[EComposer] ecom-d6eo1pbgxkf', e);
                            }
                        });
                    
                        document.querySelectorAll('.ecom-rxsy2fuhpo').forEach(function(el){
                            try {
                                Func.call({$el: el, id: 'ecom-rxsy2fuhpo', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                            } catch (e) {
                                console.error('[EComposer] ecom-rxsy2fuhpo', e);
                            }
                        });
                    
                        document.querySelectorAll('.ecom-qpo6nyrpv8m').forEach(function(el){
                            try {
                                Func.call({$el: el, id: 'ecom-qpo6nyrpv8m', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                            } catch (e) {
                                console.error('[EComposer] ecom-qpo6nyrpv8m', e);
                            }
                        });
                    
                        document.querySelectorAll('.ecom-1rm9bll89je').forEach(function(el){
                            try {
                                Func.call({$el: el, id: 'ecom-1rm9bll89je', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                            } catch (e) {
                                console.error('[EComposer] ecom-1rm9bll89je', e);
                            }
                        });
                    
                        document.querySelectorAll('.ecom-8s9w67v4hv4').forEach(function(el){
                            try {
                                Func.call({$el: el, id: 'ecom-8s9w67v4hv4', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                            } catch (e) {
                                console.error('[EComposer] ecom-8s9w67v4hv4', e);
                            }
                        });
                    
                        document.querySelectorAll('.ecom-i207ue8usi').forEach(function(el){
                            try {
                                Func.call({$el: el, id: 'ecom-i207ue8usi', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                            } catch (e) {
                                console.error('[EComposer] ecom-i207ue8usi', e);
                            }
                        });
                    
                        document.querySelectorAll('.ecom-hl0stoc5c8l').forEach(function(el){
                            try {
                                Func.call({$el: el, id: 'ecom-hl0stoc5c8l', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                            } catch (e) {
                                console.error('[EComposer] ecom-hl0stoc5c8l', e);
                            }
                        });
                    
                        document.querySelectorAll('.ecom-l944su5av5a').forEach(function(el){
                            try {
                                Func.call({$el: el, id: 'ecom-l944su5av5a', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                            } catch (e) {
                                console.error('[EComposer] ecom-l944su5av5a', e);
                            }
                        });
                    
                        document.querySelectorAll('.ecom-qa5k1wgggpq').forEach(function(el){
                            try {
                                Func.call({$el: el, id: 'ecom-qa5k1wgggpq', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                            } catch (e) {
                                console.error('[EComposer] ecom-qa5k1wgggpq', e);
                            }
                        });
                    
                        document.querySelectorAll('.ecom-qqnilw2lbge').forEach(function(el){
                            try {
                                Func.call({$el: el, id: 'ecom-qqnilw2lbge', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                            } catch (e) {
                                console.error('[EComposer] ecom-qqnilw2lbge', e);
                            }
                        });
                    
                        document.querySelectorAll('.ecom-1ce8ven0i4pj').forEach(function(el){
                            try {
                                Func.call({$el: el, id: 'ecom-1ce8ven0i4pj', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                            } catch (e) {
                                console.error('[EComposer] ecom-1ce8ven0i4pj', e);
                            }
                        });
                    
                        document.querySelectorAll('.ecom-4pzm3fss0vm').forEach(function(el){
                            try {
                                Func.call({$el: el, id: 'ecom-4pzm3fss0vm', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                            } catch (e) {
                                console.error('[EComposer] ecom-4pzm3fss0vm', e);
                            }
                        });
                    
                        document.querySelectorAll('.ecom-xg7c4c2b2r').forEach(function(el){
                            try {
                                Func.call({$el: el, id: 'ecom-xg7c4c2b2r', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                            } catch (e) {
                                console.error('[EComposer] ecom-xg7c4c2b2r', e);
                            }
                        });
                    
                        document.querySelectorAll('.ecom-3ma33flr2xy').forEach(function(el){
                            try {
                                Func.call({$el: el, id: 'ecom-3ma33flr2xy', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                            } catch (e) {
                                console.error('[EComposer] ecom-3ma33flr2xy', e);
                            }
                        });
                    
                        document.querySelectorAll('.ecom-wcj296ye1cb').forEach(function(el){
                            try {
                                Func.call({$el: el, id: 'ecom-wcj296ye1cb', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                            } catch (e) {
                                console.error('[EComposer] ecom-wcj296ye1cb', e);
                            }
                        });
                    
                        document.querySelectorAll('.ecom-cpwhyy92r4s').forEach(function(el){
                            try {
                                Func.call({$el: el, id: 'ecom-cpwhyy92r4s', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                            } catch (e) {
                                console.error('[EComposer] ecom-cpwhyy92r4s', e);
                            }
                        });
                    
                        document.querySelectorAll('.ecom-tycjye750sk').forEach(function(el){
                            try {
                                Func.call({$el: el, id: 'ecom-tycjye750sk', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                            } catch (e) {
                                console.error('[EComposer] ecom-tycjye750sk', e);
                            }
                        });
                    
                        document.querySelectorAll('.ecom-oyrpz7m5jt').forEach(function(el){
                            try {
                                Func.call({$el: el, id: 'ecom-oyrpz7m5jt', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                            } catch (e) {
                                console.error('[EComposer] ecom-oyrpz7m5jt', e);
                            }
                        });
                    
                        document.querySelectorAll('.ecom-0t3a2kw50ubm').forEach(function(el){
                            try {
                                Func.call({$el: el, id: 'ecom-0t3a2kw50ubm', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                            } catch (e) {
                                console.error('[EComposer] ecom-0t3a2kw50ubm', e);
                            }
                        });
                    

                })();
            
;try{
 
} catch(error){console.error(error);}